export const getContentAreaMaxWidth = (columns: number): number => {
  const widthInPixels = (1240 / 12) * columns;
  return widthInPixels;
};
